export const FETCH_TUTORS_REQUEST = "FETCH_TUTORS_REQUEST";
export const FETCH_TUTORS_SUCCESS = "FETCH_TUTORS_SUCCESS";
export const FETCH_TUTORS_FAILURE = "FETCH_TUTORS_FAILURE";

export const ADD_TUTOR_REQUEST = "ADD_TUTOR_REQUEST";
export const ADD_TUTOR_SUCCESS = "ADD_TUTOR_SUCCESS";
export const ADD_TUTOR_FAILURE = "ADD_TUTOR_FAILURE";

export const UPDATE_TUTOR_REQUEST = "UPDATE_TUTOR_REQUEST";
export const UPDATE_TUTOR_SUCCESS = "UPDATE_TUTOR_SUCCESS";
export const UPDATE_TUTOR_FAILURE = "UPDATE_TUTOR_FAILURE";

export const DELETE_TUTOR_REQUEST = "DELETE_TUTOR_REQUEST";
export const DELETE_TUTOR_SUCCESS = "DELETE_TUTOR_SUCCESS";
export const DELETE_TUTOR_FAILURE = "DELETE_TUTOR_FAILURE";
